// Consent API — UU PDP compliance endpoints.
// Import and call from stores only, never from components.

import { apiClient } from '@/api/client'
import type { ApiResponse, ConsentInput, ConsentStatus } from '@/types'

export const consentApi = {
  /** GET /me/consents — returns consent status for the authenticated user. */
  getStatus: () =>
    apiClient.get<ApiResponse<ConsentStatus>>('/me/consents'),

  /** POST /me/consents — submits re-consent for policy version updates. */
  reConsent: (consents: ConsentInput[]) =>
    apiClient.post<ApiResponse<{ message: string }>>('/me/consents', { consents }),

  /** DELETE /me/consents/:type — revokes a specific consent type. */
  revoke: (type: string) =>
    apiClient.delete<ApiResponse<{ message: string }>>(`/me/consents/${type}`),
}
